import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(routes)/events/hackathons/hackathon2022/_components/FinalPresentations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hackathon/header/HeaderImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hackathon/SeeYouNextYear.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
